import type { OfficeCity } from './office-city';

/**
 * Both offices, in the order the site lists them. Mirrors `OfficeCities.All`, and the pair follows
 * `booking-city.ts` / `booking-cities.ts`: the type in one file, the vocabulary in the other.
 */
export const OFFICE_CITIES: readonly OfficeCity[] = ['Astana', 'Almaty'];
